import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {

  private api = environment.apiUrl + 'session/';
  private readonly headers = {
    headers: new HttpHeaders({
      "Authorization": `Bearer ${environment.apiKeyInternal}`
    }),
    withCredentials: true
  };

  constructor(private http: HttpClient) { }

  login(username: string, password: string) {
    const body = `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`;

    return this.http.post(
      this.api + 'login.php',
      body,
      {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${environment.apiKeyInternal}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        }),
        withCredentials: true
      }
    );
  }

  logout(): Observable<any> {
    return this.http.post<any>(
      this.api + 'logout.php',
      {},
      this.headers
    );
  }

  check(): Observable<any> {
    return this.http.get(
      this.api + 'check.php',
      this.headers,
    );
  }
}
